import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import i18n from "../../../../constants/i18n";
import { USER_SEARCH_TYPE } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import KhattabatAdvancedCriteriaFields from "./KhattabatAdvancedCriteriaFields";
import KhattabatAdvancedOptionFields from "./KhattabatAdvancedOptionFields";

const KhattabatUserAdvancedForm = withLiteObserverAndTheme(() => {
  const {
    searchType,
    changeSearchType,
    shouldShowOptionForm,
    shouldShowCriteriaForm,
    disableSearchGetButton,
    getUserData
  } = getUserAdvancedStore();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <RadioGroup
          row
          value={searchType.get()}
          onChange={({ target }) => changeSearchType(target.value)}
        >
          {USER_SEARCH_TYPE.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio size="small" />}
              label={option.label}
            />
          ))}
        </RadioGroup>
        {shouldShowOptionForm.get() ? <KhattabatAdvancedOptionFields /> : null}
        {shouldShowCriteriaForm.get() ? (
          <KhattabatAdvancedCriteriaFields />
        ) : null}
        <Button
          variant="contained"
          disabled={disableSearchGetButton.get()}
          onClick={() => getUserData(true)}
          sx={{ ml: "auto", whiteSpace: "nowrap", alignSelf: "flex-end" }}
        >
          {i18n.get("GET")}
        </Button>
      </Stack>
    </Paper>
  );
});

export default KhattabatUserAdvancedForm;
